module.exports = __webpack_public_path__ + "img/user5.68398c05.png";